import { MarketingContentPreview } from '@occc-app/design-system';
import {
  Table,
  TableBody,
  TableContainer,
  TableHeader,
  TableRow,
  TableCell,
  TableHead,
  Typography,
  Link,
} from '@occc/ui-design-system';
import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';
import { ActivateTransactionFulfilledOfferFragment } from '@occc/graphql';
import { routeCreator } from '@occc-app/routes/Campaign/utils';
import { Link as ReactRouterLink } from 'react-router-dom';
import { pluralize } from '@occc-app/lib/strings';

type TransactionViewFulfillmentProps = {
  offers: ActivateTransactionFulfilledOfferFragment[];
};

export const TransactionViewFulfillment = ({ offers }: TransactionViewFulfillmentProps) => (
  <TableContainer>
    <TableHeader title={`${offers.length} ${pluralize(offers.length, 'Offer')} Fulfilled`} />
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Marketing Content</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>End Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {offers.map((offer) => (
          <TableRow key={offer.id}>
            <TableCell>
              {offer.campaign?.uuid ? (
                <Link
                  component={ReactRouterLink}
                  to={routeCreator.offerDetails(offer.campaign.uuid, offer.id)}
                  role='link'
                  color={(theme) => theme.palette.text.primary}
                >
                  {offer.name}
                </Link>
              ) : (
                <Typography>{offer.name}</Typography>
              )}
            </TableCell>
            <TableCell>
              <MarketingContentPreview
                title={offer.marketingContents?.[0]?.title || 'No Name Provided'}
                description={
                  offer.marketingContents?.[0]?.shortDescription || 'No Description Provided'
                }
                imageUrl={offer.marketingContents?.[0]?.imageUrl ?? undefined}
              />
            </TableCell>
            <TableCell>
              {offer.publishAt
                ? formatDateTime(new Date(offer.publishAt), DateTimeFormat.DateWithYear)
                : 'N/A'}
            </TableCell>
            <TableCell>
              {offer.expireAt
                ? formatDateTime(new Date(offer.expireAt), DateTimeFormat.DateWithYear)
                : 'N/A'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
